const constraints = (formatMessage, messages) => ({
	firstName: {
		presence: {
			message: formatMessage(messages.errFirstNameEmpty),
			allowEmpty: false,
		},
		length: {
			maximum: 255,
			tooLong: formatMessage(messages.errFirstNameTooLong),
		},
	},
	lastName: {
		presence: {
			message: formatMessage(messages.errLastNameEmpty),
			allowEmpty: false,
		},
		length: {
			maximum: 255,
			tooLong: formatMessage(messages.errLastNameTooLong),
		},
	},
	email: {
		presence: {
			message: formatMessage(messages.errEmailEmpty),
			allowEmpty: false,
		},
		email: {
			message: formatMessage(messages.errEmailInvalid),
		},
		length: {
			maximum: 255,
			tooLong: formatMessage(messages.errEmailTooLong),
		},
	},
	confirmEmail: {
		presence: {
			message: formatMessage(messages.errConfirmEmailEmpty),
			allowEmpty: false,
		},
		equality: {
			attribute: 'email',
			message: formatMessage(messages.errConfirmEmailMismatch),
		},
	},
});

export default constraints;
